module.exports = __webpack_public_path__ + "static/img/zndlyb.97a5cb4c.png";